<div @show class="body" [formGroup]="formGroup">

    <div class="input-wrapper wide block">

        <mat-form-field class="width"  appearance="fill" style="margin-left: 2.4rem;">
            <mat-label>Titel</mat-label>
            <input formControlName="issuetitle" matInput />
        </mat-form-field>

    </div>

    <div class="input-wrapper medium">
        <mat-icon class="icon">domain</mat-icon>
        <app-select-customer style="flex: 1" formControlName="issuecustomer" [formControl]="customerFormControl" label="Kunde" [appearance]="'fill'"></app-select-customer>
        <mat-error *ngIf="customerControl.hasError('required')">
            Es muss ein Kunde gewählt werden
        </mat-error>
    </div>

    <div class="input-wrapper medium">
        <mat-icon class="icon">location_on</mat-icon>
        <app-select-contact style="flex: 1" formControlName="localcontactpersonalid" [customerSetted]="customerControl.value" label="Ansprechpartner vor Ort" [appearance]="'fill'"></app-select-contact>
    </div>

    <div class="input-wrapper medium">
        <mat-icon class="icon">work_outline</mat-icon>
        <app-select-contact style="flex: 1" formControlName="commercialcontactpersonalid" [customerSetted]="customerControl.value" label="Geschäftlicher Ansprechpartner" [appearance]="'fill'"></app-select-contact>
    </div>

    <div class="input-wrapper wide block">

        <mat-icon class="icon">edit</mat-icon>

        <mat-form-field class="width"  appearance="fill">
            <mat-label>Beschreibung</mat-label>
            <textarea formControlName="issuedesc" matInput></textarea>
        </mat-form-field>

    </div>

    <div class="input-wrapper medium">
        <mat-icon class="icon">speed</mat-icon>
        <app-select-priority-form style="flex: 1" formControlName="issuepriority" label="Priorität"></app-select-priority-form>
    </div>

    <div class="input-wrapper medium">
        <mat-icon class="icon">checklist</mat-icon>
        <app-select-category-form style="flex: 1" formControlName="issuecategory" label="Kategorie"></app-select-category-form>
    </div>

    <div class="input-wrapper medium">
        <mat-form-field class="width" appearance="fill" style="margin-left: 2.4rem;">
            <mat-label>Wunschdatum</mat-label>
            <input formControlName="issueescalation" [matDatepicker]="escalationDatepicker" matInput />
            <mat-datepicker-toggle matSuffix [for]="escalationDatepicker"></mat-datepicker-toggle>
            <mat-datepicker #escalationDatepicker disabled="false"></mat-datepicker>
        </mat-form-field>
    </div>

    <div class="input-wrapper wide block">

        <quill-editor 
            style="margin-left: 2.4rem;"
            class="quill" 
            theme="snow" 
            format="html" 
            formControlName="issuenote" 
            [modules]="quillModules"
        ></quill-editor>

    </div>

</div>